export default __webpack_public_path__ + "cd09bf0f90ef4240a7e7e419283b323a.png";